import React from 'react';
import {
  Container,
  Title,
  Section,
  IndustriesGrid,
  IndustryCard,
  IndustryName,
  IndustryExample,
  IndustryHeader
} from './style';

import {
  FaOilCan,
  FaIndustry,
  FaHeartbeat,
  FaUniversity,
  FaChartLine
} from 'react-icons/fa';

import { motion } from 'framer-motion';

const industries = [
  { name: 'Energy and Oil', example: 'Smart grid monitoring', icon: FaOilCan },
  { name: 'Industry', example: 'Automated production analytics', icon: FaIndustry },
  { name: 'Healthcare and Pharmaceuticals', example: 'AI-powered diagnostics', icon: FaHeartbeat },
  { name: 'Government Institutions', example: 'e-Government portals', icon: FaUniversity },
  { name: 'Financial and Commercial Companies', example: 'Fraud detection systems', icon: FaChartLine },
];

const IndustriesWeServe = () => (
  <motion.div
    initial={{ opacity: 0, x: 30 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.6 }}
  >
    <Container>
      <Section>
        <Title>Industries We Serve</Title>
        <IndustriesGrid>
          {industries.map(({ name, example, icon: Icon }, index) => (
            <IndustryCard key={index}>
              <IndustryHeader>
                <Icon />
                <IndustryName>{name}</IndustryName>
              </IndustryHeader>
              <IndustryExample>{example}</IndustryExample>
            </IndustryCard>
          ))}
        </IndustriesGrid>
      </Section>
    </Container>
  </motion.div>
);

export default IndustriesWeServe;
